import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ShieldAlert } from "lucide-react";

/* 🛡 Stake Guard — "are you sure?" popup when a stake is risky for the balance.
   X / "keep my stake" continues with their stake; one tap applies the safer one. */
const StakeGuardDialog = ({ guard, onDecide, currency = "USD" }) => {
  if (!guard) return null;
  const { stake, assess } = guard;
  const rec = assess.recommended;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onDecide(stake); }}>
      <DialogContent data-testid="stake-guard-dialog" className="max-w-md bg-[#0B0E14] border-[#F7B731]/40 text-white">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-mono text-base text-[#F7B731]">
            <ShieldAlert className="w-5 h-5" /> Hold up — check this stake
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p data-testid="stake-guard-summary" className="text-sm font-mono">
            You're about to play <b className="text-[#F23645]">${stake.toFixed(2)}</b> with a <b>${assess.balance.toFixed(2)} {currency}</b> balance.
          </p>
          <ul className="space-y-1.5">
            {assess.reasons.map((r, i) => (
              <li key={i} data-testid={`stake-guard-reason-${i}`} className="text-[11px] font-mono text-white/70 leading-snug rounded-md border border-[#F23645]/30 bg-[#F23645]/5 px-2.5 py-2">
                ⚠️ {r}
              </li>
            ))}
          </ul>
          {rec != null ? (
            <button data-testid="stake-guard-use-reco" onClick={() => onDecide(rec)}
              className="w-full h-12 rounded-lg bg-[#089981] hover:bg-[#0ab293] text-black font-black font-mono text-sm transition-colors">
              ✓ USE RECOMMENDED ${rec.toFixed(2)} INSTEAD
            </button>
          ) : (
            <p data-testid="stake-guard-no-reco" className="text-[10px] font-mono text-white/50 rounded-md border border-white/10 bg-white/5 px-2.5 py-2">
              Even the minimum stake runs deep for this balance with the current recovery depth — consider a lower recovery depth or a smaller session before playing.
            </p>
          )}
          <button data-testid="stake-guard-keep" onClick={() => onDecide(stake)}
            className="w-full h-10 rounded-lg border border-white/20 text-white/60 hover:border-white/40 font-mono text-[11px] font-bold transition-colors">
            I'm sure — keep my ${stake.toFixed(2)} stake
          </button>
          <p className="text-[9px] font-mono text-white/35">this is a guide, not a block — every play is still ~50/50, so size stakes you can afford to lose</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default StakeGuardDialog;
